<template>
  <div class="product-footer">
    <div class="pagination">
      <a class="prew" :class="{disabled: isFirstProduct}" @click="prev()">предыдущая</a>
      <!-- Если карточка товара в презентации, подставить номер из текущего товара -->
      <p class="page-num" @click="goToCatalog()">{{ productInfo.number }}</p> 
       <!-- Если карточка товара из магазина, подставить индекс текущего товара -->
      <!-- <p v-else class="page-num" @click="goToCatalog()">{{ indexProductInCollection + 1 }}</p> -->
      <a v-if="!isLastProduct" class="next" @click="next()">следущая</a>
      <a v-else @click.prevent="$router.push('/order')" class="next">Завершить</a>
    </div>
  </div>
</template>
<script>
export default {
  props: ["collection", "element", "productInfo", "clickRight", "clickLeft", "isShopPage", "indexProductInCollection"],
  data: () => ({}),
  methods: {
    next(){
      let collectionProducts = this.$localStorageGet('currentCollection'); //Информация о текущей коллекции
      let currentIndex = collectionProducts.products.findIndex( el => el.id == this.element); //Индекс текущего товара в объекта товаров коллекции
      let nextProductID = collectionProducts.products[currentIndex + 1].id;
      this.$router.push('/catalog/'+this.collection+'/'+nextProductID);
      
    },
    prev(){
      let collectionProducts = this.$localStorageGet('currentCollection'); //Информация о текущей коллекции
      let currentIndex = collectionProducts.products.findIndex( el => el.id == this.element); //Индекс текущего товара в объекта товаров коллекции
      let nextProductID = collectionProducts.products[currentIndex - 1].id;
      this.$router.push('/catalog/'+this.collection+'/'+nextProductID);
      
    },
    goToCatalog(){
      this.$router.push('/catalog/' + this.collection);
    }
  },
  created(){
    if(this.$localStorageGet('currentCollection').products.findIndex( el => el.id == this.element) == 0){

    }
  },
  computed: {
    isFirstProduct(){ //Заблокировать кнопку "назад" на первом элементе
      if(this.$localStorageGet('currentCollection').products.findIndex( el => el.id == this.element) == 0){
        this.$emit('firstProduct', true)
        return true
      }else{
        this.$emit('firstProduct', false)
        return false
      }
    },
    isLastProduct(){
      let totalProducts = this.$localStorageGet('currentCollection').products.length;
      if(this.$localStorageGet('currentCollection').products.findIndex( el => el.id == this.element) == (totalProducts - 1)){
        this.$emit('lastProduct', true)
        return true
      }else{
        this.$emit('lastProduct', false)
        return false
      }
    }
  }, 
  watch: {
    // clickRight(newVal, oldVal){
    //   if(newVal){
    //     this.next()
    //   }
    // },
    // clickLeft(newVal, oldVal){
    //  if(newVal){
    //     this.prev()
    //   }
    // },
  }
};
</script>
<style lang="scss" scoped>
  .disabled{
    opacity: 0.3;
    pointer-events: none;
  }
</style>